const RENDER_AVAILABILITY_MS = 5 * 24 * 60 * 60 * 1000;

function toValidDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function isRenderDownloadExpired(render, now = new Date()) {
  const currentTime = toValidDate(now);
  if (!currentTime) return true;

  const explicitExpiry = toValidDate(render?.availableUntil);
  if (explicitExpiry) {
    return currentTime.getTime() >= explicitExpiry.getTime();
  }

  const start = toValidDate(render?.completedAt) || toValidDate(render?.createdAt);
  if (!start) return true;

  return currentTime.getTime() >= start.getTime() + RENDER_AVAILABILITY_MS;
}
